<template>
  <div>
    <vxe-grid
      auto-resize
      :loading="loading"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="200"
      size="small"
      resizable
      border
      :checkbox-config="{
        highlight: true
      }"
      ref="vxeGrid"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="$emit('submitDel', row.orderBatchCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    headerCellStyle({ column, columnIndex }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff'
        }
      }
    }
  }
}
</script>
